<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni

  This file DateBlock.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  DateBlock.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: DateBlock 
 Created by keni.
 with: IntelliJ IDEA
 Date: 12/09/2018
 Time: 10:50
------------------------------------------------------------------------------->
<template>
    <div data-element="date-block" class="p-0 vue-js-date-block">
        <div v-if="typeof date !== 'undefined' && date !== null"
             class="text-center d-flex flex-column">
            <strong class="vue-js-date-block--top">{{getDateString(date,'month')}}{{getDateString(date,'day')}}</strong>
            <span class="vue-js-date-block--bottom">
                    <span>{{getDateString(date,'year')}}</span>
            </span>
            <div v-if="add_time">
                    <span class="font-weight-normal text-capitalize">
                        <span>{{getDateString(date,'time')}}</span>
                    </span>
            </div>
        </div>
        <div v-else class="text-center fs-14">
            <strong>TBA</strong>
        </div>


    </div>
</template>

<script>
	import {
		getDate,
		getTime,
		setDate,
		getYear,
		getMonth,
		getDay
	} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';

	/**
	 * Creates a UI date block with day on top and month-year below
	 */
	export default {
		name: "date-block",
		components: {},
		props: {
			date: String,
			alt: String,
			add_time: Boolean
		},
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {
			getDateString(date, type) {
				switch (type) {
					case 'year':
						if (typeof date !== 'undefined' && date !== null) {
							return getYear(date, true);

						}
						else {
							return 'TBA';
						}

					case 'month':
						if (typeof date !== 'undefined' && date !== null) {
							return getMonth(date, 'name_short');

						}
						else {
							return null;
						}

					case 'day':
						if (typeof date !== 'undefined' && date !== null) {
							return getDay(date, 'num_short');

						}
						else {
							return null;
						}

					case 'time':
						if (typeof date !== 'undefined' && date !== null) {
							return getTime(date);

						}
						else {
							return null;
						}

					default:
						console.error('no date defined', date);

				}
			}
		},
		watch: {},
		computed: {}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dates/DateBlock.vue